export const HealthImprovementYes = 'HealthImprovementYes'

export const section = 'section'
export const smokingType = 'smokingType'
export const DateRangeMatrixType = 'DateRangeMatrix'
export const DateRange = 'DateRange'
export const SingleChoiceType = 'SingleChoice'
export const QuestionSet = 'QuestionSet'
export const FormRow = 'FormRow'
export const TelephoneNo = 'TelephoneNo'
export const QuestionTextOnly = 'QuestionTextOnly'
export const MultiChoiceCheckbox = 'MultiChoiceCheckbox'
export const AdvancedMultiChoiceCheckbox = 'AdvancedMultiChoiceCheckbox'
export const RepeatableMatrix = 'RepeatableMatrix'
export const SingleSelect = 'SingleSelect'
export const SingleLineText = 'SingleLineText'
export const InstructionsAndInformationSection = 'InstructionsAndInformationSection'
export const TeamReviewSection = 'TeamReviewSection'
/** Shared PDF / major POA form heading (team review + concern dividers). */
export const PoaPdfFormHeadingClassName = 'poa-pdf-form-heading'
/** FormRow with 2+ fields; PDF-only rules live under `.pdf-theme`. */
export const PoaPdfMultiFieldRowClassName = 'poa-pdf-multi-field-row'
export const Textarea = 'Textarea'
export const Actions = 'Actions'
export const SingleCheckBox = 'SingleCheckBox'
export const TeamReviewOutcome = 'TeamReviewOutcome'
export const TeamReviewOutcomeDefer = 'Defer'
export const TeamReviewOutcomeFail = 'Fail'
export const TeamReviewOutcomePass = 'Pass'


export const UnavailableDatesPatient = 'UnavailableDatesPatient'
export const outsideQuestionnaire = 'outsideQuestionnaire'
export const informationPackName = 'InformationPackName'
export const maxDateRanges = 10

export const FieldWidthPx = 'FieldWidthPx'
export const FieldWidthPct = 'FieldWidthPct'
export const FieldStyles = 'FieldStyles'
export const LabelClasses = 'LabelClasses'
export const GenerateNumberRange = 'GenerateNumberRange';
export const AllowDecimal = 'AllowDecimal';
export const DefaultDebounceTime = 500

export const ConfigAutoGenerateRange = {
    CurrentYear: "currentYear"
};

// Range generation patterns
export const RangePatterns = {
    LastPrefix: "last-",
    YearsSuffix: "-years"
};

/** Matches an optional negative sign followed by digits only (integers, no decimal point) */
export const INTEGER_REGEX = /^-?\d*$/;

/** Matches up to 3 digits with an optional single decimal place (e.g. cm, kg) */
export const DECIMAL_3_DIGITS_1_DP_REGEX = /^\d{0,3}(\.\d{0,1})?$/;

/** Matches up to 2 whole digits (e.g. feet, stone, pounds) */
export const TWO_DIGIT_REGEX = /^\d{0,2}$/;
